/* eslint-disable @typescript-eslint/no-explicit-any */
import { faPhone } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import {
  getOrderTracking,
  getVendorOrderTracking,
  OrderTracking as OrderTrackingType,
  updateOrderTracking
} from 'api/orders/_requests';
import Button from 'components/base/Button';
import Mapbox from 'components/base/MapBox';
import Section from 'components/base/Section';
import PageBreadcrumb from 'components/common/PageBreadcrumb';
import OrderTrackingTimeline from 'components/timelines/OrderTrackingTimeline';
import { defaultBreadcrumbItems } from 'data/commonData';
import { orderTrackingTimelineData } from 'data/timelineData';
import { Fragment, useEffect, useState } from 'react';
import { Card, Col, Row } from 'react-bootstrap';
import toast from 'react-hot-toast';
import { useSelector } from 'react-redux';
import { RootState } from 'redux-state/store';

const OrderTracking = () => {
  const { user } = useSelector((state: RootState) => state.auth);
  const [orderTracking, setOrderTracking] = useState<OrderTrackingType[]>([]);
  const [otherDetails, setOtherDetails] = useState<any>([]);

  useEffect(() => {
    const fetchOrderTracking = async () => {
      const res =
        user?.role === 'vendor'
          ? await getVendorOrderTracking()
          : await getOrderTracking();
      setOrderTracking(res);
      setOtherDetails(res);
    };

    fetchOrderTracking();
  }, []);

  const handleUpdateOrderTracking = async (
    orderId: string,
    status: string,
    index: number
  ) => {
    await updateOrderTracking(orderId, status).then(res => {
      toast.success('Order status updated successfully');
      const temp = [...orderTracking];
      temp[index].orderTracking.push({
        status,
        date: new Date().toLocaleString()
      });
      setOrderTracking(temp);
    });
  };

  return (
    <div className="pt-5 mb-9">
      <Section small className="py-0">
        {/* <PageBreadcrumb items={defaultBreadcrumbItems} /> */}
        {orderTracking?.map((item, index) => (
          <Fragment key={item._id}>
            <div className="d-flex gap-3 flex-wrap justify-content-between align-items-end mb-5">
              <div>
                <h2>Order #{item.orderId} Status</h2>
                {/* <p className="text-body-secondary mb-0">
              Payment Via{' '}
              <a className="fw-bold" href="#!">
                Cash on delivery
              </a>
              ,<br className="d-sm-none" />
              <span className="ms-sm-1">Nov 12, 2021, 8:54AM.</span>
            </p> */}
              </div>
              {/* <Button variant="outline-primary">
            <FontAwesomeIcon icon={faPhone} className="me-2" />
            Call Support
          </Button> */}
            </div>
            <Row className="gy-9 gx-5 mb-8">
              <Col xs={6} lg={user?.role === 'vendor' ? 4 : 6}>
                <Mapbox
                  className="border rounded-3 min-vh-50"
                  options={{
                    center: [-74.0020158, 40.7228022],
                    zoom: 15,
                    scrollZoom: false
                  }}
                />
              </Col>
              <Col xs={12} lg={user?.role === 'vendor' ? 4 : 6}>
                <OrderTrackingTimeline data={item.orderTracking} />
              </Col>
              {user?.role === 'vendor' && (
                <Col xs={12} lg={4} className="min-vh-50">
                  <Card>
                    <Card.Body>
                      <h5 className="mb-4">Update Order Status</h5>
                      <select
                        className="form-select"
                        value={
                          item.orderTracking[item.orderTracking.length - 1]
                            ?.status
                        }
                        onChange={e => {
                          handleUpdateOrderTracking(
                            item._id,
                            e.target.value,
                            index
                          );
                        }}
                      >
                        <option value="processing" disabled>
                          Processing
                        </option>
                        <option
                          value="pickup"
                          disabled={item.orderTracking.length > 1}
                        >
                          Pickup
                        </option>
                        <option
                          value="shipping"
                          disabled={item.orderTracking.length > 2}
                        >
                          Shipping
                        </option>
                        <option
                          value="shipped"
                          disabled={item.orderTracking.length > 3}
                        >
                          Shipped
                        </option>
                        <option
                          value="delivered"
                          disabled={item.orderTracking.length > 4}
                        >
                          Delivered
                        </option>
                      </select>
                    </Card.Body>
                  </Card>
                  <Card className="mt-6">
                    <Card.Body>
                      <h5 className="mb-4">Order Details</h5>
                      <p>
                        <span className="fw-bold">Customer Name:</span>{' '}
                        {otherDetails[index].customerName}
                      </p>
                      <p>
                        <span className="fw-bold">Number of Products:</span>{' '}
                        {otherDetails[index].products}
                      </p>
                      <p>
                        <span className="fw-bold">Shipping Address:</span>
                        {otherDetails[index].shippingAddress.street},{' '}
                        {otherDetails[index].shippingAddress.city},{' '}
                        {otherDetails[index].shippingAddress.state},{' '}
                        {otherDetails[index].shippingAddress.postalCode},{' '}
                        {otherDetails[index].shippingAddress.country}
                      </p>
                      <p>
                        <span className="fw-bold">Order Value:</span>{' '}
                        {otherDetails[index].finalAmount}
                      </p>
                      <p>
                        <span className="fw-bold">Contact Number:</span>{' '}
                        {otherDetails[index].shippingAddress.phone}
                      </p>
                    </Card.Body>
                  </Card>
                </Col>
              )}
            </Row>
            {index < orderTracking.length - 1 && (
              <hr className="separator separator-dotted text-dark mb-8" />
            )}
          </Fragment>
        ))}
      </Section>
    </div>
  );
};

export default OrderTracking;
